import './App.css';

import BingoCard from './BingoCard'

function App() {
  return (
    <div className="App">
      <BingoCard />
    </div>
  );
}

export default App;
